import React, { useEffect, useState } from 'react'
import QRCode from 'qrcode'
import styles from './QRCodeAuth.module.scss'
import { userActions } from '../../../Redux/_actions/index'
import {useDispatch, useSelector} from "react-redux"
import {selectAuth} from "../../../Redux/selectors/selectors"
import { Skeleton } from 'antd'
import {STATUS} from "../../../helpers/constants"
import { Button } from 'antd'

const QRCodeAuth = ({onQrShow}) => {
	const [qrUrl, setQRUrl] = useState(null)
	const { qrGenerate, qrCheck } = userActions
	const dispatch = useDispatch()

	const { qrCode, qrCheckStatus } = useSelector(selectAuth)

	const createLink = () => {
		const os = window.navigator.platform

		if (os.includes('Mac') || os.includes('iPod') || os.includes('iPad') || os.includes('iPhone')) {
			return 'https://apps.apple.com/us/app/gtobase/id1591933670'
		}

		return 'https://play.google.com/store/apps/details?id=com.gtobasemobile&hl=ru&gl=US&pli=1'
	}

	useEffect(() => {
		if (qrCode) {
			QRCode.toDataURL(qrCode, {
				width: 200,
				height: 200,
				errorCorrectionLevel: 'H',
				type: 'image/jpeg',
				quality: 1,
				margin: 5,
				color: {
					dark: '#15171F',
					light: '#FFFFFF',
				},
			})
				.then((url) => {
					setQRUrl(url)
				})
				.catch((err) => {
					console.error(err)
				})
		}
	}, [qrCode])

	useEffect(() => {
		if (!qrCode) {
			dispatch(qrGenerate())
		}
	}, [])

	useEffect(() => {
		let interval = setInterval(() => {
			dispatch(qrCheck(qrCode))
		}, 3000)

		if (qrCode && qrCheckStatus && qrCheckStatus === STATUS.SUCCESS) {
			return  clearInterval(interval)
		}

		return () => {
			clearInterval(interval)
		}
	}, [qrCode, qrCheckStatus])

	return (
		<div className={styles.qrCodeAuthContainer}>
			{qrCode ?
				(<img src={qrUrl} alt={'qr-code-auth'}/>) :
				(<Skeleton.Image active style={{width: '200px', height: '200px'}} />)
			}
			<div className={styles.textContainer}>
				<p className={styles.text}>
					Use
					<Button type="link" href={createLink()} size={"small"}>GTO Base mobile app </Button>
					to sign in with QR-code
				</p>
			</div>
			<Button size={'middle'} className={styles.backAuthButton} onClick={() => onQrShow(false)}>
				Use another sign in method
			</Button>
		</div>
	)
}

export default QRCodeAuth
